import { DailyActivityDatatype } from '../components/components/DailyActivities/dailyactivity.d';
import * as Lambda from './LambdaApi';

const listActivities = async (facilityId) => {
    try {
        const apiPath = `/s2l/${facilityId}/activities`
        const response = await Lambda.Get(apiPath, {}, 'lambda')
        if (response.success) {
            console.log('List activities response:', response)
            return response.Result.Content.Result
        }
        return []
    } catch (error) {
        console.error(error)
        throw Error(error)
    }
}

const getSignedImageUrls = async (facilityId, requestBody) => {
    const { activityId, fileNames } = requestBody
    const apiPath = `/s2l/${facilityId}/getSignedActivityImageUrls`
    const response = await Lambda.Post(
        apiPath, {
            activityId,
            fileNames
        }, 
        'lambda'
    )
    console.log('Response of getSignedImageUrls: ', response)
    if (response.Result.Success) {
        return response
    } else {
        throw Error('Something went wrong while getting signed image URLs!')
    }
}

export {
    listActivities,
    getSignedImageUrls
}
